import { getMessages } from 'app/store/constants';

export const CARD_TAG_CREATE = getMessages().getText('card_form_tag_create');
export const CARD_TAG_SEARCH = getMessages().getText('card_form_tag_search');
export const CARD_TAG_CREATE_BUTTON = getMessages().getText('card_form_tag_create_button');
